<template>
  <div class="newsCon">
    <el-timeline>
      <!-- <el-timeline-item timestamp="2018/8/11" placement="top">
        <el-card>
          <h4>参观关向应纪念馆，向先烈致敬</h4>
          <img src="@/assets/news/2018_8_11.jpg" alt="">
        </el-card>
      </el-timeline-item>
      <el-timeline-item timestamp="2018/4/29" placement="top">
        <el-card>
          <h4>世有科技2018年“三八妇女节”活动</h4>
          <p>2018/4/12 20:46</p>
        </el-card>
      </el-timeline-item> -->
      <el-timeline-item
        v-for="(x, i) in list"
        :key="i"
        :timestamp="x.time"
        placement="top"
        @click.native="gotoWechat(x)"
      >
        <el-card>
          <h4>{{ x.title }}</h4>
          <img v-lazy="x.path" />
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<style scoped>
.newsCon {
  width: calc(100% - 32px - 64px);
  /* 64是padding */
  max-width: 766px;
  margin: 0 auto;
  background-color: #ffffff;
  overflow: hidden;
  margin-top: 32px;
  margin-bottom: 132px;
  padding: 32px;
}
.newsCon h4 {
  color: #303133;
  padding: 8px 0;
  font-size: 18px;
}
.newsCon img {
  max-width: 100%;
  border-radius: 4px;
  max-height: 200px;
}
</style>

<script>
import { news } from "@/assets/productions.js";
export default {
  data() {
    return {
      list: news
    };
  },
  methods: {
    gotoWechat(x) {
      window.open(x.wechat);
    }
  }
};
</script>
